import { lazy } from "react";
import { Route, Routes } from "react-router-dom";

import { AppShell } from "@/components/layout/AppShell";
import { RouteFallback } from "@/components/layout/RouteFallback";
import { Toaster } from "@/components/ui/Toaster";
import { RequireAuth, useAuthBootstrap } from "@/lib/auth";

// Route-level code splitting — each page is its own chunk behind <Suspense>
// in AppShell (RouteFallback). Named exports wrapped to default for lazy().
const Login = lazy(() => import("@/pages/Login").then((m) => ({ default: m.Login })));
const Overview = lazy(() => import("@/pages/Overview").then((m) => ({ default: m.Overview })));
const Targets = lazy(() => import("@/pages/Targets").then((m) => ({ default: m.Targets })));
const TargetDetail = lazy(() =>
  import("@/pages/TargetDetail").then((m) => ({ default: m.TargetDetail })),
);
const RegisterWizard = lazy(() =>
  import("@/pages/RegisterWizard").then((m) => ({ default: m.RegisterWizard })),
);
const Machines = lazy(() => import("@/pages/Machines").then((m) => ({ default: m.Machines })));
const Restore = lazy(() => import("@/pages/Restore").then((m) => ({ default: m.Restore })));
const Retention = lazy(() => import("@/pages/Retention").then((m) => ({ default: m.Retention })));
const Audit = lazy(() => import("@/pages/Audit").then((m) => ({ default: m.Audit })));
const NotFound = lazy(() => import("@/pages/NotFound").then((m) => ({ default: m.NotFound })));

export function App() {
  // Resolve the OIDC session once on mount. Until it completes we hold first
  // paint of the guarded routes so an already-authenticated operator never
  // flashes the login screen (and a 401 cleanly falls through to Login).
  const bootstrapped = useAuthBootstrap();
  if (!bootstrapped) return <RouteFallback />;

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route index element={<Overview />} />
          <Route path="targets" element={<Targets />} />
          <Route path="targets/new" element={<RegisterWizard />} />
          <Route path="targets/:id" element={<TargetDetail />} />
          <Route path="machines" element={<Machines />} />
          <Route path="restore" element={<Restore />} />
          <Route path="settings/retention" element={<Retention />} />
          <Route path="settings/audit" element={<Audit />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster />
    </>
  );
}
